import { AiToolOffice } from '../ai-details/ai-tool-office';
import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddQuestionTempCategoryComponent } from '../addQuesTempCategory/addQuesTempCategory.component';
import { AddQualifyingTempCategoryComponent } from '../addQualifyingTempCategory/addQualifyingTempCategory.component';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-importQualifyingTemplate',
  templateUrl: './importQualifyingTemplate.component.html',
  styleUrls: ['./importQualifyingTemplate.component.scss'] 
})

export class ImportQualifyingTemplateComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 
  spinner:boolean=false;

 
  filteredTaskCategoryList: any = ([] = []);
  ShowNoRecordFoundTaskTemplates: Boolean = false;
  taslTemplateID: number = 0;
  showSaveTemplate: Boolean = false;
  QuestionTemplateID: number = 0; 

  updateQuestionTemplateButton: boolean = false;
  selectedcategoryIDForQuestion: number = 0; 
 
  searchTemplateQuestion: string = '';
  categoryType: number = 0;

  timeout = null;

  rolesAsssign:any=[]=[];


  officeIdForImportPromptTemp: number = 0;
  organizationIdForImportPromptTemp: number = 0;
  templateIDImportTask: number = 0;
  newQuestionsTOUpdate:any=[]=[];
  queryBlocks:any=[]=[];
  ShowNoRecordFoundQuestionTemplate: boolean = false;
  NLPTemplatesList:any=[]=[];
  currentIndex: number = 0;
  selectedTemplate: any = ([] = []);
  filteredTempCategoryList: any = ([] = []);
  searchTemplateName: string = '';
  ShowNoRecordFoundTemplates: boolean = false;
  ImportTemplatesList: any = ([] = []);
  TemplateIDImportTask: number = 0;
  selectedcategoryIDForImportTemp: number = 0;
  showImportTemplate: boolean = false;
  filteredQualifyingCategoryList: any = ([] = []);
  QualifyingCategoryList: any = ([] = []);
  QualifyingTemplatesList: any = ([] = []);
  QualifyingTemplatesListFilter: any = ([] = []);
  templateID: number = 0;
  totalRules:number=0;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<ImportQualifyingTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach((oe:any) => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID = AiToolOffice.resolve(oe.officeID);   // [per-office] the office the open AI tool works for
      });
    }    
  }  
  
  ngOnInit(): void {     
    this.getReferralTemplateCategories();
    this.getReferralTemplates();
  }
     
   getReferralTemplateCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      isCategoriesOnly: true,
      isAll: false,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      type: this.categoryType > 0 ? this.categoryType : 0,
    };
    this.coreService.getReferralTemplateCategories(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingCategoryList = response.data;
          this.filteredQualifyingCategoryList = this.QualifyingCategoryList.filter((m) => m.type == this.categoryType);
        } else {
          this.QualifyingCategoryList = [];
          this.filteredQualifyingCategoryList = [];
        }
      } else {
        this.QualifyingCategoryList = [];
        this.filteredQualifyingCategoryList = [];
      }
    });
  }

   getReferralTemplates() {
    var ReqModel = {
      templateType: this.categoryType, // For My Template
      categoryID: this.selectedcategoryIDForQuestion,
      isAll: true,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    };
    this.coreService.getReferralTemplates(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if(this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.QualifyingTemplatesList = response.data;
          this.QualifyingTemplatesListFilter = response.data;
          if (this.QualifyingTemplatesList.length > 0) {
            this.ShowNoRecordFoundQuestionTemplate = false;
          } else {
            this.ShowNoRecordFoundQuestionTemplate = true;
          }
        } else {
          this.QualifyingTemplatesList = [];
          this.QualifyingTemplatesListFilter = [];
        }
      } else {
        this.QualifyingTemplatesList = [];
        this.QualifyingTemplatesListFilter = [];
      }
    });
  }
  
   closeDialog(){   
    this.dialogRef.close();
  }
    
  SelectTemplateQuestionTempForImport(data:any) {   
    this.templateIDImportTask=0;
    this.totalRules=0;
    this.totalRules = data.questionCounts + this.data.total;
    if (this.totalRules >= 20) {
      this.toastr.warning('A maximum of 20 AI Qualifying Questions can be imported.', '', {
        timeOut: 6000,
      });     
      return;
    }    
    this.officeIdForImportPromptTemp = data.officeID;
    this.organizationIdForImportPromptTemp = data.organizationID;
    this.templateIDImportTask = data.templateID;
  }

   getThroughCategoryForQualifyingTempImport(e: any, i: any) {
    this.templateIDImportTask = 0;
    this.currentIndex = i;
    this.selectedcategoryIDForQuestion = e;
    this.getReferralTemplates();
  }

   OnSelectCategoryImportTemp($event:any) {
    this.selectedTemplate = [];
    this.currentIndex=0;
    this.templateIDImportTask = 0;
    this.selectedcategoryIDForQuestion = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getReferralTemplateCategories();
    this.getReferralTemplates();
  }

  originOfficeID:number=0;
  originOrgID:number=0;

   importQualifyingTemplates() {
    if(this.data.From=="AITools"){
      this.importFromAITools();
    }
    if(this.data.From=="AIAutomationTemplates"){
      var obj={
      //tempalteName:this.tempalteName,
      referralTemplateID:this.templateIDImportTask
     }
     this.dialogRef.close(obj);
    }
  }

    importFromAITools(){
     var ReqModel = {
      documentID:this.data.documentId,
      originUserID: this.currentUser.UID,
      originOfficeID:Number(this.officeIdForImportPromptTemp),
      originOrgID:Number(this.organizationIdForImportPromptTemp),
      copyUserID: this.currentUser.UID,
      copyOfficeID:Number(this.myOfficeID),
      copyOrgID:Number(this.organizationId),
      templateID:Number(this.templateIDImportTask) 
    };
    this.loaderService.show();
    this.coreService.importReferralQuestionsFromTemplate(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();          
          this.toastr.success('Template Import successfully.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');
          //this.closeDialog();
        } else {
          this.toastr.error('Template Import failed.', '', {
            timeOut: 3000,
          });
          this.loaderService.hide();
        }
      } else {
        this.toastr.error('Template Import failed.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
    }
  

   
}
